<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/ITS_serpref">Series preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/ITS_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/ITS_abbrev">Abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/ITS_ch01"><span class="bold">1 Concerning foreigners and the Former Prophets</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch01#sigil_toc_id_2">Being a foreigner and reading the Bible</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch01#sigil_toc_id_3">Why the Former Prophets?</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch01#sigil_toc_id_4">Towards an ethical and theological reading of the Former Prophets</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/ITS_ch02"><span class="bold">2 The book of Joshua: the identity of the people of God</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_6">Initial observations: the genre and language of Joshua</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_7">Rahab and the initial entry into the land (Josh. 1 – 6)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_8">Achan (Josh. 7:1 – 8:29)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_9">The altar on Mount Ebal and the Gibeonites (Josh. 8:30 – 12:24)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_10">Caleb, the surviving Canaanites and the cities of refuge (Josh. 13 – 21)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_11">The altar on the Jordan (Josh. 22)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_12">The threat of all and an invitation to all (Josh. 23 – 24)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/ITS_ch02#sigil_toc_id_13">Conclusions: Joshua as the formation of the people of God</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ITS_ch03" title="Link target outside of Sample"><span class="bold">3 The book of Judges: the people through whom Yahweh works</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch03#sigil_toc_id_15" title="Link target outside of Sample">Initial orientation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch03#sigil_toc_id_16" title="Link target outside of Sample">After Joshua: Judges 1:1 – 3:6</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch03#sigil_toc_id_17" title="Link target outside of Sample">The stories of the judges: Judges 3:7 – 16:31</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch03#sigil_toc_id_18" title="Link target outside of Sample">When there was no king: Judges 17 – 21</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch03#sigil_toc_id_19" title="Link target outside of Sample">Conclusions on Judges: the people through whom Yahweh works</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ITS_ch04" title="Link target outside of Sample"><span class="bold">4 The books of Samuel: foreigners as the means of assessing Israel</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_21" title="Link target outside of Sample">Initial orientation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_22" title="Link target outside of Sample">Samuel: 1 Samuel 1 – 12</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_23" title="Link target outside of Sample">Saul: 1 Samuel 13 – 15</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_24" title="Link target outside of Sample">Saul and David, Ish-bosheth and David: 1 Samuel 16:1 – 2 Samuel 5:16</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_25" title="Link target outside of Sample">David as king: 2 Samuel 5:17 – 24:25</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch04#sigil_toc_id_26" title="Link target outside of Sample">Conclusions: Samuel and understanding the people of God</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ITS_ch05" title="Link target outside of Sample"><span class="bold">5 The books of Kings: foreigners beyond the borders of Israel</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch05#sigil_toc_id_28" title="Link target outside of Sample">Initial orientation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch05#sigil_toc_id_29" title="Link target outside of Sample">Solomon: 1 Kings 1 – 11</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch05#sigil_toc_id_30" title="Link target outside of Sample">Two kingdoms: 1 Kings 12 – 2 Kings 13</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch05#sigil_toc_id_31" title="Link target outside of Sample">The fall of the kingdoms: 2 Kings 14 – 25</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch05#sigil_toc_id_32" title="Link target outside of Sample">Conclusions: kings and foreigners beyond the borders of Israel</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ITS_ch06" title="Link target outside of Sample"><span class="bold">6 Foreigners and the people of God</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch06#sigil_toc_id_34" title="Link target outside of Sample">Initial orientation: key themes from the Former Prophets</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch06#sigil_toc_id_35" title="Link target outside of Sample">Echoes in the Old Testament</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch06#sigil_toc_id_36" title="Link target outside of Sample">Echoes in the New Testament</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/ITS_ch06#sigil_toc_id_37" title="Link target outside of Sample">Pointers for an ethic towards foreigners</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ITS_biblio" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ITS_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ITS_idx_aut" title="Link target outside of Sample">Search names for authors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ITS_idx_scr" title="Link target outside of Sample">Search items for Scripture references</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ITS_idx_ancsrc" title="Link target outside of Sample">Search items for ancient sources</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ITS_sertit" title="Link target outside of Sample">Titles in this series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/aboutcontrib" title="Link target outside of Sample">About the contributors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ITS_contents.vue?a6a700e2